export abstract class BaseUser {

    constructor() { }

}
